import { compose, lifecycle, withProps } from "recompose";
import { connect } from "react-redux";
import { fetchClub } from "shadow-client/endpoints/clubApi";
import { withTranslator } from "app/decorators";
import Immutable from "immutable";
import ValidClubList from "./ValidClubList";

const mapStateToProps = ({ entities }, { clubIdsExcluded }) => ({
  excludedClubs: clubIdsExcluded.map(id => entities.getIn(["clubs", id])).filter(i => i)
});

const lifecycles = {
  async componentWillMount() {
    const { fetchClub, clubIdsExcluded } = this.props;
    await Promise.all(clubIdsExcluded.map(clubId => fetchClub(clubId)));
  }
};

export default compose(
  withTranslator,
  withProps(({ productBehavior }) => ({
    clubIdsExcluded: productBehavior.getIn(["configuration", "clubsExcluded"]) || Immutable.List()
  })),
  connect(mapStateToProps, { fetchClub }),
  lifecycle(lifecycles)
)(ValidClubList);



// WEBPACK FOOTER //
// ./src/app/components/ProductPage/ValidClubList/ValidClubList.container.js